import { forwardRef, type LegacyRef } from 'react';
import ImageGalleryConfigContent from './ImageGalleryConfigContent';

export interface ImageGalleryConfigProps {
  project_id: number;
  site_id: number;
  open: boolean;
  grid_type: 'reports' | 'grids';
  grid_id: number;
  widget_id: string;
}

function ImageGalleryConfig(
  {
    open: _isModalOpen,
    site_id,
    project_id,
    grid_type,
    grid_id,
    widget_id,
  }: ImageGalleryConfigProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return (
    <ImageGalleryConfigContent
      site_id={site_id}
      project_id={project_id}
      grid_type={grid_type}
      grid_id={grid_id}
      widget_id={widget_id}
      ref={ref}
    />
  );
}

export default forwardRef(ImageGalleryConfig);
